import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { OrganizationDto } from '../../../models/organization/dto/organization.dto';
import { MY_ORGANIZATIONS_QUERY_KEY } from './useGetMyOrganizations';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useCreateOrganization = (onSuccess: (data: OrganizationDto) => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();
    return useMutation({
        mutationKey: ['createOrganization'],
        mutationFn: async (body: { name: string; }) => {
            const response = await apiClient.fetchApi<OrganizationDto, { name: string; }>({ method: 'POST', endpoint: `organizations`, body });
            return response
        },
        onSuccess: (data: OrganizationDto) => {
            queryClient.setQueryData(MY_ORGANIZATIONS_QUERY_KEY, (oldData: OrganizationDto[] | undefined) => {
                return oldData ? [...oldData, data] : [data];
            });

            if (!selectedOrganization && data) {
                setSelectedOrganization(data);
            }

            onSuccess(data);
        }
    });
};